import { ElementType } from 'polotno/model/group-model';
import { ShapeType } from 'polotno/model/shape-model';
import { getClientRect } from 'polotno/utils/math';

export const getBoundingBox = (element: ElementType) => {
    return getClientRect(element as ShapeType);
};
